module.exports = __webpack_public_path__ + "static/media/Mobile_Payment.36b73ed5.png";